import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatDate, formatEUR } from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/ui-kit";
import { Scale } from "lucide-react";

export default function Notaire() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/dossiers").then((r) => {
      const arr = r.data.filter((d) => d.date_notaire).sort((a, b) => (a.date_notaire || "").localeCompare(b.date_notaire || ""));
      setItems(arr);
    }).finally(() => setLoading(false));
  }, []);

  const today = new Date().toISOString().slice(0, 10);
  const upcoming = items.filter((d) => (d.date_notaire || "").slice(0, 10) >= today);
  const past = items.filter((d) => (d.date_notaire || "").slice(0, 10) < today);

  return (
    <div className="p-8" data-testid="notaire-page">
      <PageHeader title="Passages notaire" subtitle="Rendez-vous à venir et passés" />

      <div className="mb-6">
        <h2 className="text-sm font-semibold uppercase tracking-wider text-[#111111] mb-3">À venir ({upcoming.length})</h2>
        <div className="bg-white rounded-sm border border-slate-200 overflow-hidden">
          {loading ? <div className="p-10 text-center text-slate-500">Chargement…</div> :
            upcoming.length === 0 ? <EmptyState icon={Scale} title="Aucun passage notaire planifié" /> :
            <table className="w-full text-sm">
              <thead className="bg-slate-50"><tr>
                <th className="text-left px-4 py-3 font-semibold uppercase text-xs">Date</th>
                <th className="text-left px-4 py-3 font-semibold uppercase text-xs">Client</th>
                <th className="text-left px-4 py-3 font-semibold uppercase text-xs">Notaire</th>
                <th className="text-left px-4 py-3 font-semibold uppercase text-xs">Programme / Lot</th>
                <th className="text-right px-4 py-3 font-semibold uppercase text-xs">Prix</th>
              </tr></thead>
              <tbody>{upcoming.map((d) => (
                <tr key={d.id} className="border-t border-slate-100 hover:bg-slate-50">
                  <td className="px-4 py-3 font-semibold text-[#B8873A]">{formatDate(d.date_notaire)}</td>
                  <td className="px-4 py-3"><Link to={`/dossiers/${d.id}`} className="font-semibold text-[#111111] hover:text-[#B8873A]">{d.client_prenom} {d.client_nom}</Link></td>
                  <td className="px-4 py-3">{d.notaire_nom || "—"}</td>
                  <td className="px-4 py-3">{d.programme || "—"} · Lot {d.lot}</td>
                  <td className="px-4 py-3 text-right font-medium">{formatEUR(d.prix)}</td>
                </tr>))}
              </tbody>
            </table>}
        </div>
      </div>

      {past.length > 0 && (
        <div>
          <h2 className="text-sm font-semibold uppercase tracking-wider text-slate-500 mb-3">Historique ({past.length})</h2>
          <div className="bg-white rounded-sm border border-slate-200 overflow-hidden">
            <table className="w-full text-sm">
              <tbody>{past.slice(0,20).map((d) => (
                <tr key={d.id} className="border-b border-slate-100 hover:bg-slate-50">
                  <td className="px-4 py-3 text-slate-500">{formatDate(d.date_notaire)}</td>
                  <td className="px-4 py-3"><Link to={`/dossiers/${d.id}`} className="font-semibold text-[#111111] hover:text-[#B8873A]">{d.client_prenom} {d.client_nom}</Link></td>
                  <td className="px-4 py-3">{d.notaire_nom || "—"}</td>
                  <td className="px-4 py-3">{d.programme || "—"}</td>
                  <td className="px-4 py-3 text-right">{formatEUR(d.prix)}</td>
                </tr>))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
